$(document).ready(function () {

    $('input[name="nombre"]').on('keyup change',function(){
        console.log('key')
        var nombre = $('input[name="nombre"]').val();
        var total = nombre * 7.5;
        $('#total_commande').val(total);
    });
});